import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/shadcn/select";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/shadcn/tooltip";
import MaterialIcon from "@/components/general/common/MaterialIcon";
import type { Tournament } from "@/api/tournaments";

interface ScoutingHeaderProps {
    selectedTournament?: string;
    onTournamentChange?: (tournament: string) => void;
    tournaments?: Tournament[];
}

export function ScoutingHeader({ selectedTournament, onTournamentChange, tournaments }: ScoutingHeaderProps) {
    const isLoading = !tournaments;

    return (
        <TooltipProvider>
            <div className="flex flex-col gap-3 mb-2 md:flex-row md:items-end md:justify-between md:gap-6 md:mb-4">
                <div>
                    <h1 className="text-2xl md:text-4xl font-black text-primary tracking-tight font-headline md:mb-2">
                        Scouting
                    </h1>
                    <p className="hidden md:block text-on-surface-variant font-medium">
                        {selectedTournament || "Select a tournament to begin scouting"}
                    </p>
                </div>

                <div id="onboarding-scouting-tournament">
                    <Select
                        value={selectedTournament || ""}
                        onValueChange={(v) => onTournamentChange?.(v)}
                        disabled={isLoading || !tournaments || tournaments.length === 0}
                    >
                        <SelectTrigger className="w-full md:w-fit bg-surface-container-highest border-0">
                            <div className="flex items-center gap-2">
                                <MaterialIcon name="sort" className="text-primary text-lg" />
                                <SelectValue placeholder="Select tournament" />
                            </div>
                        </SelectTrigger>
                        <SelectContent>
                            {tournaments && tournaments.length > 0 ? (
                                tournaments.map((tournament) =>
                                    tournament.matches.length === 0 ? (
                                        <Tooltip key={tournament.id} delayDuration={0}>
                                            <TooltipTrigger asChild>
                                                <div
                                                    className="flex items-center px-2 py-1.5 text-sm opacity-50 cursor-not-allowed text-on-surface"
                                                    onClick={(e) => e.preventDefault()}
                                                >
                                                    <div className="flex items-baseline gap-2">
                                                        <span>{tournament.name}</span>
                                                        <span className="text-sm text-on-surface-variant">
                                                            {tournament.id}
                                                        </span>
                                                    </div>
                                                </div>
                                            </TooltipTrigger>
                                            <TooltipContent side="left">
                                                <p>No data for this tournament</p>
                                            </TooltipContent>
                                        </Tooltip>
                                    ) : (
                                        <SelectItem key={tournament.id} value={tournament.name}>
                                            <div className="flex items-baseline gap-2">
                                                <span>{tournament.name}</span>
                                                <span className="text-sm text-on-surface-variant">{tournament.id}</span>
                                            </div>
                                        </SelectItem>
                                    )
                                )
                            ) : (
                                <div className="px-3 py-2 text-on-surface-variant text-sm">
                                    No tournaments available
                                </div>
                            )}
                        </SelectContent>
                    </Select>
                </div>
            </div>
        </TooltipProvider>
    );
}
